export default "skymp5-front/94cb92369d150c972c4cea09112cb0d1.png";